/**
 * Created by charnjeetelectrovese@gmail.com on 5/1/2020.
 */
import {serviceGetAppSettings, serviceUpdateGeoFence,serviceUpdatePolicies, serviceGetThemeByDomain} from "../services/AppSettings.service";
import EventEmitter from "../libs/Events.utils";
import { getClientDomain } from "../libs/domain.utils";

export const APP_SETTINGS_INIT = 'APP_SETTINGS_INIT';
export const APP_SETTINGS_DONE = 'APP_SETTINGS_DONE';
export const APP_SETTINGS_UPDATE_GEOFENCE = 'APP_SETTINGS_UPDATE_GEOFENCE';
export const APP_SETTINGS_CHANGE_THEME = 'APP_SETTINGS_CHANGE_THEME';
export const APP_SETTINGS_UPDATE_POLICIES = 'APP_SETTINGS_UPDATE_POLICIES';
export const APP_SETTINGS_SET_DOMAIN_THEME = 'APP_SETTINGS_SET_DOMAIN_THEME';

export function actionGetAppSettings(data) {
    const req = serviceGetAppSettings({});
    return (dispatch) => {
        dispatch({ type: APP_SETTINGS_INIT, payload: {} });
        req.then((data) => {
            if (!data.error) {
                const tempData = data.data;
                dispatch({ type: APP_SETTINGS_DONE, payload: tempData });
            }
        });
    };
    // return ({type: AUTH_USER, payload: data});
}


export function actionUpdateGeoFence(data) {
    const request = serviceUpdateGeoFence({ polygon: data } )
    return (dispatch) => {
        dispatch({ type: APP_SETTINGS_UPDATE_GEOFENCE, payload: data })
    }
}

export function actionChangeTheme(theme) {
    return (dispatch) => {
        try {
            localStorage.setItem('theme', theme);
        } catch (e) {
            console.error('Failed to save theme preference to localStorage:', e);
        }
        dispatch({type: APP_SETTINGS_CHANGE_THEME, payload: theme});
    }
}

export function actionUpdatePolicies(name, value) {
    const request = serviceUpdatePolicies({ name, value } ).then((res) => {
        EventEmitter.dispatch(EventEmitter.THROW_ERROR, {error: 'Saved Successfully', type: 'success'});
    });
    return (dispatch) => {
        dispatch({ type: APP_SETTINGS_UPDATE_POLICIES, payload: {name, value} })
    }
}

export function actionGetThemeByDomain(domain) {
    return async (dispatch) => {
        const currentDomain = domain || getClientDomain();
        const cacheKey = currentDomain ? `client_theme_${currentDomain}` : 'domainTheme';

        const updateUITheme = (themeData) => {
            dispatch({ type: APP_SETTINGS_SET_DOMAIN_THEME, payload: themeData });

            if (themeData && themeData.theme) {
                if (themeData.theme.fav_icon) {
                    const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                    link.type = 'image/x-icon';
                    link.rel = 'shortcut icon';
                    link.href = themeData.theme.fav_icon;
                    document.getElementsByTagName('head')[0].appendChild(link);
                }
                document.title = 'PanzyCare';
            }
        };

        const clearCachedTheme = () => {
            try {
                if (cacheKey) {
                    localStorage.removeItem(cacheKey);
                }
                localStorage.removeItem('domainTheme');
                if (currentDomain) {
                    localStorage.removeItem(`client_theme_${currentDomain}`);
                }
            } catch (e) {
                console.error("Failed to remove client theme from localStorage:", e);
            }
        };

        // 1. Guarded Read Path: Check localStorage for cached theme
        let cachedTheme = null;
        try {
            cachedTheme = localStorage.getItem(cacheKey) || (currentDomain ? localStorage.getItem('domainTheme') : null);
        } catch (e) {
            console.error("Error reading cached theme from localStorage:", e);
        }

        if (cachedTheme) {
            try {
                const parsedTheme = JSON.parse(cachedTheme);
                updateUITheme(parsedTheme);
            } catch (e) {
                console.error("Error parsing cached theme", e);
            }
        }

        // 2. Fetch latest theme from API
        try {
            const params = currentDomain ? { domain: currentDomain } : {};
            const res = await serviceGetThemeByDomain(params);
            const data = res?.data || res;
            const isSuccess = data?.response_code === 1 || (!data?.error && data?.data?.response_code === 1);

            if (isSuccess) {
                const themeData = data?.response_obj?.theme || data?.data?.response_obj?.theme;
                if (themeData) {
                    // Guarded Write Path: localStorage.setItem wrapped in try/catch
                    // If storage is full or disabled, theme update still dispatches
                    try {
                        localStorage.setItem(cacheKey, JSON.stringify(themeData));
                    } catch (e) {
                        console.error("Failed to save client theme to localStorage:", e);
                    }
                    updateUITheme(themeData);
                } else {
                    // Success response code, but theme object not found
                    clearCachedTheme();
                    updateUITheme(null);
                }
            } else {
                // Cache invalidation on failure or "not found" (domain deleted, deactivated, error)
                clearCachedTheme();
                updateUITheme(null);
            }
        } catch (error) {
            console.error("Error fetching theme:", error);
            // Invalidate cache on network/server error
            clearCachedTheme();
            updateUITheme(null);
        }
    };
}

export const actionGetClientTheme = actionGetThemeByDomain;
